'use client';

import React, { memo, useEffect, useState } from 'react';
import { MODALS } from '../../../util/constants';
import getStrapiModalInfo from '../../../util/getStrapiModalInfo';
import SweeprActionModal from '../../shared/sweepr-action-modal/SweeprActionModal';

const { BROADBAND_SUPPORT } = MODALS;

/**
 * @name BroadbandSupportModal
 * @description - Broadband Support modal component
 * @param {boolean} showBroadbandSupportModal - Toggle's the broadband support redirect modal
 * @returns {JSX.Element} Account Verification Modal
 */
const BroadbandSupportModal = ({ showBroadbandSupportModal, handleAction }) => {
  const [cmsData, setCmsData] = useState(null);
  const [load, setLoad] = useState(true);

  /**
   * @name getCmsData
   * @description Fetches data from the Strapi API
   * @returns {Promise<void>} Promise and sets the state cmsData when resolved
   */
  const getCmsData = async () => {
    const data = await getStrapiModalInfo(BROADBAND_SUPPORT);
    setCmsData(data);
  };

  useEffect(() => {
    setLoad(false);
    getCmsData();
  }, []);

  return (
    <SweeprActionModal
      id={cmsData?.attributes?.modalID}
      open={showBroadbandSupportModal?.value}
      handleClose={showBroadbandSupportModal?.disable}
      handleBack={showBroadbandSupportModal?.disable}
      title={cmsData?.attributes?.title}
      iconSrc={cmsData?.attributes?.iconSrc?.data?.attributes?.url}
      description={cmsData?.attributes?.firstHalfDescription}
      cta={cmsData?.attributes?.cta}
      load={load}
      handleAction={handleAction}
      disableCloseOnBackdropClick
      disableCloseOnEscapeKeyDown
    />
  );
};

BroadbandSupportModal.displayName = 'BroadbandSupportModal';
export default memo(BroadbandSupportModal);
